import React from "react";
import Select from "react-select";
import { Button } from "aible";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faEyeSlash, faCog, faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";

import styles from "./style.module.css";

import { STEP_TYPE, WIZARD_SECTIONS } from "containers/Wizard/reducer";

import WizardHeader from "components/Wizard/WizardHeader";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import ProgressIndicator from "components/CreateWizard/Utils/ProgressIndicator";

export default class WizardStep extends React.PureComponent {
  renderAdvanced() {
    const {
      isAdvanced,
      isEditBlueprint,
      name,
      index,
      isWizardShow,
      isCurrentStep,
      type,
      removeStep,
      stepLength,
      incrementStep,
      increasePriority,
      decreasePriority,
      options,
      updateOption,
      isNextEnabled,
      isCreating,
      nextName,
      hasNext,
      isHover,
      stepNum,
      stepTotal,
      stepSize,
      children,
      hideNext,
      showBlueprintCreate,
      updateIsEditing
    } = this.props;

    const isLocked = options && options["lock"];
    const isHidden = options && options["hide"];

    return (
      <div
        className={
          styles.wizardStepHolder +
          " " +
          (isWizardShow ? styles.wizardStepShow : "") +
          " " +
          (options && options["hide"] === true ? styles.wizardHidden : "") +
          " " +
          (type === STEP_TYPE.CHOOSE_DATASET.id ? "chooseDataset" : "")
        }
        id={"wizardStep_" + index}
      >
        <div className={styles.wizardStep + " " + (isHover ? styles.hoverStep : "")}>
          <WizardHeader {...this.props} />
          <div className={styles.wizardStepContent}>
            {children}
            {isWizardShow && hasNext && isCurrentStep && !hideNext && (
              <div className={styles.footer}>
                <div className={styles.nextButton} id="continueButton">
                  {isCreating !== true ? (
                    <React.Fragment>
                      {showBlueprintCreate && (
                        <Button onClick={() => updateIsEditing(true)} type="secondary" style={{ marginRight: "30px" }}>
                          {"Create Blueprint"}
                        </Button>
                      )}
                      <Button onClick={() => incrementStep(index)} type="primary" disabled={!isNextEnabled}>
                        {nextName}
                      </Button>
                    </React.Fragment>
                  ) : (
                    <div className={styles.createHolder}>
                      {"Creating Model Frontier"}
                      <LoadingIndicator style={{ marginLeft: "10px", transform: "scale(0.75)" }} />
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {
      id,
      isAdvanced,
      isEditBlueprint,
      isHeader,
      index,
      type,
      removeStep,
      incrementStep,
      isNextEnabled,
      isWizardShow,
      isCurrentStep,
      hasNext,
      nextName,
      children
    } = this.props;

    if (isHeader) {
      return <WizardHeader {...this.props} />;
    }

    if (id === "new" && type === STEP_TYPE.SUCCESS.id && isWizardShow && isEditBlueprint === false) {
      return <LoadingIndicator />;
    }

    return this.renderAdvanced();
  }
}
